<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  viewBox="0 0 24 24"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M19 2C20.6569 2 22 3.34315 22 5V19C22 20.6569 20.6569 22 19 22H5C3.34315 22 2 20.6569 2 19V5C2 3.34315 3.34315 2 5 2H19ZM20 8H4V19C4 19.5523 4.44772 20 5 20H19C19.5523 20 20 19.5523 20 19V8ZM12.1168 17.9933L12.0001 18L11.916 17.996L11.7994 17.9798L11.688 17.9503L11.5769 17.9063L11.4794 17.854L11.4049 17.8037L11.293 17.7071L8.2929 14.7071C7.90237 14.3166 7.90237 13.6834 8.2929 13.2929C8.65339 12.9324 9.22064 12.9047 9.61294 13.2097L9.70715 13.2929L11 14.585L11.0001 11C11.0001 10.4872 11.3861 10.0645 11.8835 10.0067L12.0001 10C12.5524 10 13.0001 10.4477 13.0001 11L13 14.585L14.2931 13.2929C14.6535 12.9324 15.2208 12.9047 15.6131 13.2097L15.7073 13.2929C16.0678 13.6534 16.0955 14.2206 15.7905 14.6129L15.7073 14.7071L12.7072 17.7071L12.6217 17.7834L12.5519 17.8341L12.454 17.8913L12.3401 17.9407L12.2661 17.9642L12.1168 17.9933ZM19 4H5C4.44772 4 4 4.44772 4 5V6H20V5C20 4.44772 19.5523 4 19 4Z"
    fill="currentColor"
  />
</svg>
